import { Auth } from 'aws-amplify';
import { useEffect, useState } from 'react';

export default () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      console.log('LOADING USER');
      setLoading(true);
      try {
        const user = await Auth.currentAuthenticatedUser();
        setUser(user);
      } catch (e) {
        setError(e);
        setUser(null);
      }
      console.log('LOADED USER');
      setLoading(false);
    };
    fetch();
    return () => {};
  }, []);

  return [user, loading, error];
};

export function isUserEligibleToCfuDevices(user) {
  // TODO: I'm hoping that this ugly check here will be scrapped off soon enough [18/12/25]
  return user?.attributes?.['custom:company']?.toLowerCase() === 'sunergy';
}
